import api from './api';

export interface MDTCase {
  id: number;
  patient_id: string;
  title: string;
  status: string;
  diagnosis?: string | null;
  disease_status?: string | null;
  relapse_details?: string | null;
  performance_status?: string | null;
  treatment_intent?: string | null;
  relapse_date?: string | null;
  disease_site?: string | null;
  previous_treatment_summary?: string | null;
  comorbidities?: string | null;
  investigation_summary?: string | null;
  created_by?: number | null;
  assigned_oncologist_id?: number | null;
  assigned_histopathologist_id?: number | null;
  assigned_radiologist_id?: number | null;
  assigned_supportive_care_id?: number | null;
  oncologist_review_status: string;
  histopathologist_review_status: string;
  radiologist_review_status: string;
  supportive_care_review_status: string;
  oncologist_review_notes?: string | null;
  histopathologist_review_notes?: string | null;
  radiologist_review_notes?: string | null;
  supportive_care_review_notes?: string | null;
  Creator?: { id: number; name: string; email: string };
  AssignedOncologist?: { id: number; name: string; email: string };
  AssignedHistopathologist?: { id: number; name: string; email: string };
  AssignedRadiologist?: { id: number; name: string; email: string };
  AssignedSupportiveCare?: { id: number; name: string; email: string };
  createdAt: string;
  updatedAt: string;
}

export interface CaseCompleteness {
  case_id: number;
  is_complete: boolean;
  missing_fields: string[];
  message: string;
}

export const getMDTCasesByPatient = async (patientId: string): Promise<MDTCase[]> => {
  const response = await api.get(`/mdt-cases/patient/${patientId}`);
  return response.data.data;
};

export const getMDTCaseById = async (caseId: number): Promise<MDTCase> => {
  const response = await api.get(`/mdt-cases/${caseId}`);
  return response.data.data;
};

export const createMDTCase = async (data: {
  patient_id: string;
  title: string;
  diagnosis?: string;
  disease_status?: string;
  relapse_details?: string;
  performance_status?: string;
  treatment_intent?: string;
  relapse_date?: string;
  disease_site?: string;
  previous_treatment_summary?: string;
  comorbidities?: string;
  investigation_summary?: string;
  assigned_oncologist_id?: number;
  assigned_histopathologist_id?: number;
  assigned_radiologist_id?: number;
  assigned_supportive_care_id?: number;
}): Promise<MDTCase> => {
  const response = await api.post('/mdt-cases', data);
  return response.data.data;
};

export const updateMDTCase = async (caseId: number, data: Partial<{
  title: string;
  status: string;
  diagnosis: string;
  disease_status: string;
  relapse_details: string;
  performance_status: string;
  treatment_intent: string;
  relapse_date: string;
  disease_site: string;
  previous_treatment_summary: string;
  comorbidities: string;
  investigation_summary: string;
  assigned_oncologist_id: number;
  assigned_histopathologist_id: number;
  assigned_radiologist_id: number;
  assigned_supportive_care_id: number;
  oncologist_review_status: string;
  histopathologist_review_status: string;
  radiologist_review_status: string;
  supportive_care_review_status: string;
  oncologist_review_notes: string;
  histopathologist_review_notes: string;
  radiologist_review_notes: string;
  supportive_care_review_notes: string;
}>): Promise<MDTCase> => {
  const response = await api.put(`/mdt-cases/${caseId}`, data);
  return response.data.data;
};

export const deleteMDTCase = async (caseId: number): Promise<void> => {
  await api.delete(`/mdt-cases/${caseId}`);
};

export const validateCaseCompleteness = async (caseId: number): Promise<CaseCompleteness> => {
  const response = await api.post(`/mdt-cases/${caseId}/validate`);
  return response.data.data;
};
